import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";

// Large left-hand homepage sponsor panel. Source-aware: renders an admin-managed
// affiliate campaign (source="affiliate") or a self-serve advertiser ad (source="active").
export function SponsorFeaturePanel({ ad, source = "affiliate", placement = "homepage_sponsor" }) {
  const id = ad?.id;
  useEffect(() => {
    if (!id) return;
    if (source === "affiliate") api.post(`/affiliate/${id}/impression`, { placement, category: ad.category || "", page_url: window.location.pathname }).catch(() => {});
    else api.post(`/ads/${id}/impression`).catch(() => {});
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!ad) return null;

  const onClick = () => {
    if (!id) return;
    if (source === "affiliate") api.post(`/affiliate/${id}/click`, { placement, category: ad.category || "", page_url: window.location.pathname }).catch(() => {});
    else api.post(`/ads/${id}/click`).catch(() => {});
  };

  const href = source === "affiliate" ? ad.href : ad.destination_url;
  const partner = ad.partner || ad.brand_name || "";
  const html = source === "affiliate" ? ad.custom_html_safe : "";

  return (
    <div className="lg:col-span-2 border border-gray-900 p-8 flex flex-col justify-center" data-testid="home-sponsor-feature">
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-widest font-bold text-gray-500 flex items-center gap-1">
          <span className="w-1.5 h-1.5 bg-pti-red inline-block" aria-hidden="true" /> {ad.label || "Advertisement"}
        </span>
        {ad.category && <span className="text-[11px] uppercase tracking-wider text-gray-400">{ad.category}</span>}
      </div>

      {html ? (
        <div className="mt-5 affiliate-html [&_img]:max-w-full [&_img]:h-auto [&_img]:mx-auto" onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />
      ) : (
        <>
          {(partner || ad.logo) && (
            <div className="flex items-center gap-2 mt-5">
              {ad.logo && <img src={ad.logo} alt="" className="w-6 h-6 object-contain" />}
              {partner && <span className="text-sm font-bold text-gray-700">{partner}</span>}
            </div>
          )}
          <h3 className="font-display text-3xl font-bold mt-2 leading-tight">{ad.headline}</h3>
          {ad.description && <p className="text-gray-600 mt-2 max-w-lg">{ad.description}</p>}
          {href && (
            <a href={href} target={ad.target || "_blank"} rel="noopener noreferrer sponsored" onClick={onClick}
              data-testid="home-sponsor-feature-cta"
              className="inline-flex items-center gap-2 mt-5 bg-pti-red text-white px-5 py-2.5 font-bold w-fit hover:bg-pti-black transition-colors">
              {ad.cta || "Learn more"} <ArrowRight size={16} />
            </a>
          )}
        </>
      )}
    </div>
  );
}
